/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popURef.vue?vue&type=template&id=6417f8d9&scoped=true"
import script from "./popURef.vue?vue&type=script&lang=js"
export * from "./popURef.vue?vue&type=script&lang=js"
import style0 from "./popURef.vue?vue&type=style&index=0&id=6417f8d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6417f8d9",
  null
  
)

export default component.exports